import { LinearProgress } from '@mui/material';
import { IReactionDisposer, reaction } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { AppStore } from './store/AppStore';

import './css/AppLoadingBarStyles.css';

interface IAppLoadingBarProps {
}

class AppLoadingBar extends React.Component<IAppLoadingBarProps> {

    private readonly appStore = AppStore;
    private reactionDisposer?: IReactionDisposer;

    componentDidMount() {
        this.reactionDisposer = reaction(
            () => [this.appStore.isCarregando, this.appStore.valorCarregamento],
            () => this.forceUpdate()
        );
    }

    componentWillUnmount() {
        this.reactionDisposer?.();
    }

    public render() {
        const { isCarregando, valorCarregamento } = this.appStore;
        return (
            <div className="loading-bar">
                {isCarregando ?
                    <LinearProgress color='inherit' variant={valorCarregamento} aria-label='Barra de progresso' />
                    :
                    <LinearProgress color='primary' variant="determinate" value={100} aria-label='Barra de progresso'/>
                }
            </div>
        );
    }
}

export default observer(AppLoadingBar);
